'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.default = TableHeaderCell;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./table.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * WH Table Header Cell Component.
 * @param {Object} props The new component properties.
 * @returns {React$Element<any>}  HTML markup for the component
 */
function TableHeaderCell(props) {
    var _props$className = props.className,
        className = _props$className === undefined ? '' : _props$className,
        _props$colSpan = props.colSpan,
        colSpan = _props$colSpan === undefined ? 1 : _props$colSpan,
        _props$rowSpan = props.rowSpan,
        rowSpan = _props$rowSpan === undefined ? 1 : _props$rowSpan,
        onClick = props.onClick;


    var classNames = (0, _classnames2.default)((0, _defineProperty3.default)({
        'sb-table-header-cell': true
    }, '' + className, className));

    return (0, _jsx3.default)('th', {
        className: classNames,
        colSpan: colSpan,
        rowSpan: rowSpan,
        onClick: onClick
    }, void 0, props.children);
}
// css
//# sourceMappingURL=TableHeaderCell.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/table/TableHeaderCell.js
// module id = 611
// module chunks = 0